import React from 'react';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import WpButton from 'Wpds/components/button/WpButton';
import WorkspaceNotifications from '../WorkspaceNotifications/WorkspaceNotifications';

// Styles
import './WorkspaceSidebar.scss';

type Props = {
  toggleSidebar: () => void;
};

const WorkspaceSidebar = ({ toggleSidebar }: Props) => {
  const baseClassName = 'WorkspaceSidebar';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__header`}>
        <p className={`${baseClassName}__header__title`}>Updates</p>
        <div className={`${baseClassName}__header__close-btn`}>
          <WpButton size="sm" variant="tertiary" onClick={toggleSidebar}>
            <WpIcon name="times" />
          </WpButton>
        </div>
      </div>
      <div className={`${baseClassName}__content`}>
        <WorkspaceNotifications />
      </div>
    </div>
  );
};

// @josh - removing the surface sidebar list for now
// but preserving to code to easily add back in when ready
//
// const WorkspaceSidebar = ({ toggleSidebar }: Props) => {
//   enum Tabs {
//     updates = 'updates',
//     surfaceai = 'surfaceai',
//   }
//   const [activeTab, setActiveTab] = useState(Tabs.updates);

//   const { workspaceRecentUpdates } = useWorkspaceRecentUpdates();
//   const hasNewUpdates = workspaceRecentUpdates.filter(update => WorkspaceRecentUpdatesHelper.getIsNew(update)).size > 0;

//   const { newData } = useWorkspaceSurfaceData();
//   const hasSurfaceUpdates = newData && newData.length > 0;

//   const baseClassName = 'WorkspaceSidebar';

//   return (
//     <div className={baseClassName}>
//       <div className={`${baseClassName}__tabs`}>
//         <WpTabs activeTab={activeTab} onTabClick={setActiveTab}>
//           <WpTab tabId={Tabs.updates}>
//             Updates
//             {hasNewUpdates && <div className={`${baseClassName}__tabs__indicator`} />}
//           </WpTab>
//           <WpTab tabId={Tabs.surfaceai}>
//             SurfaceAI
//             {hasSurfaceUpdates && <div className={`${baseClassName}__tabs__indicator`} />}
//           </WpTab>
//         </WpTabs>
//         <div className={`${baseClassName}__tabs__close-btn`}>
//           <WpButton size="sm" variant="tertiary" onClick={toggleSidebar}>
//             <WpIcon name="times" />
//           </WpButton>
//         </div>
//       </div>
//       <div className={`${baseClassName}__content`}>
//         {activeTab === Tabs.updates && <WorkspaceNotifications />}
//         {activeTab === Tabs.surfaceai && <WorkspaceSurfaceList />}
//       </div>
//     </div>
//   );
// };

export default WorkspaceSidebar;
